import Echo from 'laravel-echo';
import Pusher from 'pusher-js';
import axios from 'axios';

window.Pusher = Pusher;

const echo = new Echo({
  broadcaster: 'pusher',
  key: process.env.REACT_APP_PUSHER_APP_KEY || 'f6a3fec636427721cf37',
  cluster: process.env.REACT_APP_PUSHER_APP_CLUSTER || 'mt1',
  forceTLS: false,
  disableStats: true,
  authorizer: (channel) => ({
    authorize: (socketId, callback) => {
      axios.post(
        "/broadcasting/auth",
        {
          socket_id: socketId,
          channel_name: channel.name,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
            Accept: 'application/json',
          },
        }
      )
        .then((res) => callback(null, res.data))
        .catch((err) => callback(err));
    },
  }),
});

export default echo;